import React from 'react';

import HiddenStatusBar from '@src/components/HiddenStatusBar';
import LocationTag from '@src/components/LocationTag';
import UserTag from '@src/components/UserTag';

import Content from './Content';
import Navigations from './Navigations';
import { Card, Container, Header, Photo, Video, VideoWrapper } from './styled';
import { Props } from './types';
import useJourneyStories from './useJourneyStories';

const Screen: React.FC<Props> = ({ route, navigation }) => {
  const stories = useJourneyStories(route.params.id);
  const [activeStory, setActiveStory] = React.useState(0);
  const [duration, setDuration] = React.useState(0);
  const handleNextPress = React.useCallback(() => {
    if (activeStory < (stories.data?.length ?? 0) - 1) {
      setDuration(0);
      setActiveStory(activeStory + 1);
    } else if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [activeStory, navigation, stories.data]);
  const handlePrevPress = React.useCallback(() => {
    if (activeStory !== 0) {
      setDuration(0);
      setActiveStory(activeStory - 1);
    } else if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [activeStory, navigation]);

  const item = React.useMemo(() => stories.data?.[activeStory], [
    activeStory,
    stories,
  ]);
  const handleViewPostPress = React.useCallback(() => {
    item?.postId && navigation.navigate('Post', { id: item.postId });
  }, [item, navigation]);

  return (
    <>
      <HiddenStatusBar />
      <Container color={item?.color}>
        <Navigations
          activeStory={activeStory}
          total={stories.data?.length ?? 0}
          duration={duration}
          onNextStoryPress={handleNextPress}
          onPrevStoryPress={handlePrevPress}
          onViewPostPress={item?.postId ? handleViewPostPress : undefined}
        >
          <Header>
            <UserTag
              barStyle="dark-content"
              date={item?.date}
              user={item?.user}
            />
            <LocationTag barStyle="dark-content" place={item?.place} />
          </Header>
          <Card>
            {item?.cover.type === 'PHOTO' ? (
              <Photo
                onLoad={() => setDuration(5000)}
                source={item.cover.source}
              />
            ) : item?.cover.type === 'VIDEO' ? (
              <VideoWrapper>
                <Video
                  onLoad={(video) =>
                    setDuration(
                      video.duration > 15 ? 15000 : video.duration * 1000
                    )
                  }
                  source={item?.cover.source}
                />
              </VideoWrapper>
            ) : null}
            <Content>{item?.content}</Content>
          </Card>
        </Navigations>
      </Container>
    </>
  );
};

Screen.displayName = 'Journey';

export default Screen;
